import { render, staticRenderFns } from "./MemorySuggestions.vue?vue&type=template&id=37dde990&scoped=true&"
import script from "./MemorySuggestions.vue?vue&type=script&lang=js&"
export * from "./MemorySuggestions.vue?vue&type=script&lang=js&"
import style0 from "./MemorySuggestions.vue?vue&type=style&index=0&id=37dde990&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37dde990",
  null
  
)

export default component.exports